import React from 'react'

import { H5 } from '@hub/heading'
import { Stack } from '@hub/stack'
import { Text } from '@hub/text'

const FreeParkingGuide: React.FC<React.PropsWithChildren<unknown>> = () => {
  const guides = [
    '1. Download and install the Westfield app.',
    "2. Go to 'Parking' and tap 'Add number plate'.",
    '3. Now next time you visit, you get to enjoy more free parking.',
  ]
  return (
    <Stack gap={'spacing-md'}>
      <H5>How to enjoy more free parking</H5>
      <Stack as={'ul'} fontSize={'font-sm'} sx={{ marginBottom: 'spacing-md' }}>
        {guides.map((guide, index) => (
          <Text key={`guide-${index}`}>{guide}</Text>
        ))}
      </Stack>
    </Stack>
  )
}

export default FreeParkingGuide
